<template>
  <div>
    <!-- 头部开始 -->
    <topPart :rightPart="true">
      <template slot="difinePort">
        <div class="btn-block" @click="show = true">
          <img class="time-icon" src="../../assets/images/deadline.png" />
          <span class="time-text">{{ date }}</span>
        </div>
      </template>
    </topPart>
    <!-- 头部结束 -->
    <!-- 时间区间组件开始 -->
    <van-calendar
      v-model="show"
      type="range"
      @confirm="onConfirm"
      color="#29BEBC"
      :show-confirm="false"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <!-- 时间区间组件结束 -->
    <!-- 选择器 -->
    <div class="menu-down">
      <van-dropdown-menu active-color="#29BEBC">
        <van-dropdown-item
          v-if="branchFlag"
          title-class="colorName"
          v-model="unionFlag"
          :options="statueList"
          @change="onFilter()"
        />
        <van-dropdown-item
          v-model="typeFlag"
          :options="typeList"
          @change="onFilter()"
        />
      </van-dropdown-menu>
    </div>
    <!-- 选择器结束 -->
    <div style="height: 100px"></div>
    <!-- 内容开始 -->
    <div
      class="list-block"
      v-infinite-scroll="loadMore"
      infinite-scroll-distance="50"
    >
      <div class="card-box card-box-pos"    @click="jump(item)" v-for="item in dataArrList" :key="item.id">
        <!-- 名称列表 -->
        <div class="list-name-title">
          <span class="nameTitleStyle">{{ item.nameName }}</span>
          <span class="departmentStyle">{{ deptNameTransfrom(item) }}</span>
        </div>
        <!-- 内容列表 -->
        <div
          class="rowBox"
          v-for="(objConfig, index) in getArrCondfig(item)"
          :key="index"
        >
          <div class="rowBoxTitle">{{ strategyFunction(objConfig, item) }}</div>
          <span
            class="type-img-box"
            :class="{ 'rowBoxConter contentColor': addColor(objConfig.title) }"
            >{{ strategy(objConfig, item) }}</span
          >

          <div class="imgBoxStype" v-if="typeImgUrl(objConfig, item)">
            <img class="imgStype" src="@/images/declare.png" />
          </div>
        </div>
          <!-- 状态图片开始 -->
          <img class="status-img" v-if="start[item.status].imgUrl" :src="start[item.status].imgUrl" />
          <!-- 状态图片结束 -->
          <!-- 审核状态 -->
          <div class="startStyleBox">
            <div :class="'startStyle '+ start[item.status].style">{{start[item.status].showTitle}}</div>
          </div>
          <!-- 审核状态结束 -->
      </div>
      <div v-if="dataArrList.length == 0" class="blank">
        <img src="@/images/404-02.png" alt />
      </div>
    </div>
    <p class="nomore" v-if="noMore">没有更多了</p>
    <!-- 内容结束 -->
  </div>
</template>

<script>
import topPart from "../../components/topPart";
import moment from "moment";
export default {
  components: {
    topPart,
  },
  data() {
    return {
      secondaryType: {},
      configObje: {
        1: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "secondaryType",
            title: "住院类型",
            isImg: true,
            fun: "typeTransfrom",
          },
          {
            key: "dataApplication",
            title: "住院日期",
            fun: "ordinary",
          },
          {
            key: "applyDate",
            title: "申请日期",
            fun: "ordinaryTime",
          },
          {
            key: "reason",
            title: "住院事由",
            fun: "ordinary",
          },
           {
            key: "handleName",
            title: "申请人",
            fun: "ordinary",
          },
        ],
        2: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            keyTwo: "money",
            key: "goods",
            title: "申请补助物品",
            titleTwo: "申请补助金额",
            fun: "ordinaryMoneyOrGoods",
            titleFun: true,
          },
          {
            key: "secondaryType",
            title: "申请补助事由",
            fun: "typeTransfromDeath",
          },
          {
            key: "applyDate",
            title: "申请日期",
            fun: "ordinaryTime",
          },
          {
            key: "handleName",
            title: "申请人",
            fun: "ordinary",
          },
        ],
        3: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "handleName",
            title: "申请人",
            fun: "ordinary",
          },
          {
            key: "reason",
            title: "申请原因及现状",
            fun: "ordinary",
          },
          {
            key: "applyDate",
            title: "申请日期",
            fun: "ordinaryTime",
          },
        ],
        4: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "handleName",
            title: "申请人",
            fun: "ordinary",
          },
          {
            key: "sex",
            title: "性别",
            fun: "typeTransfromSex",
          },
          {
            key: "age",
            title: "年龄",
            fun: "ordinary",
          },
          {
            key: "money",
            title: "申请补助金额",
            fun: "ordinary",
          },

          {
            key: "reason",
            title: "申请补助原因",
            fun: "ordinary",
          },
          {
            key: "applyDate",
            title: "申请日期",
            fun: "ordinaryTime",
          },
        ],
        5: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "handleName",
            title: "申请人",
            fun: "ordinary",
          },
          {
            key: "secondaryType",
            title: "慰问类型",
            fun: "typeTransfromOthers",
          },
          {
            key: "reason",
            title: "申请原因及现状",
            fun: "ordinary",
          },
          {
            key: "applyDate",
            title: "申请日期",
            fun: "ordinaryTime",
          },
        ],
        6:[
           {
            key: "",
            title: "申请类型",
            fun: "type",
          },
           {
            key: "post",
            title: "职务",
            fun: "ordinary",
          },
           {
            key: "dateOfSubmission",
            title: "提交日期",
            fun: "ordinary",
          },
           {
            key: "titleOfProposal",
            title: "申请标题",
            fun: "ordinary",
          },
        ]
      },
      typeTransfromOther: {},
      typeObj: {
        1: "住院慰问申请",
        2: "亲属去世申请",
        3: "大病救助申请",
        4: "困难补助申请",
        5: "其他慰问申请",
        6: "提案征集申请",
      },
      typeList: [
        { text: "全部", value: 0 },
        { text: "住院慰问", value: 1 },
        { text: "亲属去世", value: 2 },
        { text: "大病救助", value: 3 },
        { text: "其他慰问", value: 5 },
        { text: "困难补助", value: 4 },
        { text: "提案征集", value: 6 },
      ], //
      branchFlag: false,
      minDate: new Date(2017, 0, 1),
      maxDate: this.date,
      deathType: {},
      date: "时间", //显示的时间字串
      show: false, //是否显示时间区间组件
      startTime: "", //开始时间
      endTime: "", //结束时间
      configArr: [
        {
          title: "申请类型",
          key: "approvalName",
          fun: "ordinary",
        },
        {
          title: "申请日期",
          key: "createDate",
          fun: "ordinary",
        },
      ], //配置数组
      dataArrList: [], //数据列表
      start: {}, //单子状态
      currentPage: 0, //当前页数
      pageSize: 5, //每页多少个
      unionFlag: "", //分会选择标识
      typeFlag: "", //类型选择标识
      noMore: false, //是否展示更多
      typeList: [
        //分会列表
      ],
      transfromConfig: [
        { key: "value", value: "id" },
        { key: "text", value: "name" },
      ],
      statueList: [
        //类型列表
      ],
    };
  },
  created() {
    //获取申请补助事由
    this.getReasonsForSubsidy();
    //修改搜索状态
    this.getStatus();
    this.getConfigObj();
  },
  mounted() {
    this.getConfigData();
    // this.getDataList();
    this.getTreeAndSympathy();
  },
  methods: {
    ordinaryTime(obj, item) {
      var strTime = item[obj.key];
      return this.formatDate(strTime);
    },
    getConfigData() {
      var obj = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy"]
      );
      //获取申请补助事由
      // var arr = this.centralControl.utils.getConfig(obj, [
      //   "hospitalization",
      //   "hospitalizationType",
      // ]);

      //获取配置对象
      var configObj = this.centralControl.utils.getConfig(obj, ["death"]);
      //获取类型
      this.transfromDeathType(
        this.deathType,
        configObj.deathType,
        "value",
        "label"
      );

      //获取配置对象
      var configObj = this.centralControl.utils.getConfig(obj, ["sympathy"]);

      //获取类型
      this.transfromDeathType(
        this.typeTransfromOther,
        configObj.sympathyType,
        "value",
        "label"
      );

      // for (var a = 0; a < arr.length; a++) {
      //   this.secondaryType[arr[a].value] = arr[a].label;
      // }
    },
    getReasonsForSubsidyData() {
      var obj = {
        dictType: "hospitalization",
      };
      return obj;
    },
    //类型转换器
    transfromDeathType(obj, arr, key, value) {
      for (var a = 0; a < arr.length; a++) {
        obj[arr[a][key]] = arr[a][value];
      }
    },
    //获取住院类型审核
    getReasonsForSubsidy() {
      var obj = this.getReasonsForSubsidyData();
      this.centralControl.axios.centralControl(
        "getUserDictValueAllData",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            for (var a = 0; a < data.length; a++) {
              this.secondaryType[data[a].dictValue] = data[a].dictLabel;
            }
          }
        },
        obj
      );
    },
    //图片校验
    typeImgUrl(item, obj) {
      if (item.isImg) {
        if (obj[item.key] == 2) {
          if (obj.allowance == 1) {
            return true;
          }
        }
      }
      return false;
    },
    // 添加color
    addColor(data) {
      return data === "申请类型" ? true : false;
    },
    //标题转换函数
    strategyFunction(obj, item) {
      if (obj.titleFun) {
        if (item[obj.key]) {
          return obj.title;
        } else {
          return obj.titleTwo;
        }
      } else {
        return obj.title;
      }
    },
    //获取配置
    getArrCondfig(obj) {
      return this.configObje[obj.comfortType];
    },
    getStatus() {
      const loginInfo = localStorage.getItem("loginInfo");
      const currentLoginInfo = loginInfo ? JSON.parse(loginInfo) : {};
      var identity = currentLoginInfo.identity;
      this.branchFlag = "12345".includes(identity);
    },
    // 时间控件函数时间format
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // 点击确定时候
    onConfirm(date) {
      const [start, end] = date;
      this.startTime = start;
      this.endTime = end;
      this.show = false;
      this.date = `${this.formatDate(start)} 至 ${this.formatDate(end)}`;
      this.onFilter();
    },
    //下拉重新获取
    loadMore() {
      this.currentPage++;
      this.getDataList();
    },
    //跳转函数
    jump(item) {
      this.detailsOfSympathy(item);
    },
    //转换函数
    transfrom(arr, arrConfig) {
      for (var a = 0; a < arr.length; a++) {
        for (var b = 0; b < arrConfig.length; b++) {
          arr[a][arrConfig[b].key] = arr[a][arrConfig[b].value];
        }
      }
    },
    //获取组织列表和审批事项
    getTreeAndSympathy() {
      this.centralControl.axios.centralControl(
        "getOfficeTree",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            this.transfrom(data.listProcess, this.transfromConfig);
            this.transfrom(data.listBranch, this.transfromConfig);
            data.listProcess.unshift({ value: "", text: "申请类型" });
            data.listBranch.unshift({ value: "", text: "分会" });

            //赋值类型
            this.typeList = data.listProcess;
            //赋值科室
            this.statueList = data.listBranch;
          }
        },
        {}
      );
    },
    getDataList() {
      var data = {
        nowPage: this.currentPage, //当前页数
        pageSize: this.pageSize, //每页展示多少个
        applicantUnit: this.unionFlag, //分会ID
        modelId: this.typeFlag, //审批事项ID
        startTime: this.startTime, //开始时间
        endTime: this.endTime, //结束时间
        sendType: "enquiryAgent", //查询我的审批
      };
      this.centralControl.axios.centralControl(
        "enquiryAgent",
        (res) => {
          const { data, code, message } = res;
          if (code == 200) {
            const list = (data.list || []).filter(it => it.comfortType !== undefined)
            this.dataArrList = [...this.dataArrList, ...list];
            if (this.dataArrList.length > 0 && list.length == 0) {
              this.noMore = true;
              return;
            }
          }
        },
        data
      );
    },
    //科室转换器
    deptNameTransfrom(obj) {
      var stre = obj.dependName ? "-" + obj.dependName : "";
      return obj.branchName + stre;
    },
    //事由转换器
    typeTransfromOthers(item, obj) {
      return this.typeTransfromOther[obj[item.key]];
    },
    typeTransfromSex(item, obj) {
      var sex = obj[item.key];
      if (sex == "2") {
        return "女";
      } else if (sex == "1") {
        return "男";
      } else {
        return sex;
      }
    },
    //事由转换器
    typeTransfromDeath(item, obj) {
      if (obj.reason != "") {
        return obj.reason;
      }
      return this.deathType[obj[item.key]];
    },
    //金额物品转换器
    ordinaryMoneyOrGoods(obj, item) {
      if (item[obj.key]) {
        return item[obj.key];
      } else {
        return item[obj.keyTwo];
      }
    },
    //普通函数
    ordinary(item, obj) {
      return obj[item.key];
    },
    typeTransfrom(item, obj) {
      return this.secondaryType[obj[item.key]];
    },
    type(con, obj) {
      return this.typeObj[obj.comfortType];
    },
    //根据对象的key获取对象的值
    getObjAsKey(obj, key) {
      return obj[key];
    },
    //普通函数
    ordinary(item, obj) {
      return obj[item.key];
    },
    //策略函数
    strategy(item, obj) {
      return this[item.fun](item, obj);
    },
    //获取科室
    getDepartment(item) {
      var dept_name = this.getObjAsKey(item, "departmentName"); //同意函数
      return dept_name;
    },
    //获取名称标识
    getNameTitle(item) {
      return this.getObjAsKey(item, "startUserName");
    },
    //获取标示位
    getConfigObj() {
      var obj = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy"]
      );
      //单子状态
      this.start = this.centralControl.utils.getConfig(obj, ["approveStart"]);
    },
    detailsOfSympathy(orderNumber) {
      console.log('queryId',orderNumber.planId)
      if (orderNumber.planId.includes("TA")) {
        this.$router.push({
          path: "/approvalDemocratic",
          query: {
            row: orderNumber.planId, //慰问类型,
            multipleRow: JSON.stringify(orderNumber),
          },
        });
      } else {
        this.$router.push({
          path: "/detailsOfSympathy",
          query: {
            row: orderNumber.planId, //慰问类型,
            // multipleRow: JSON.stringify(orderNumber),
          },
        });
      }
    },
    //下拉框改变事件
    onFilter() {
      this.dataArrList = []; //条件选择  清空数据
      this.currentPage = 1;
      this.getDataList();
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/theme.styl';
@import '../../assets/stylus/common.styl';
  .card-box-pos {
    position:relative;
  }

.rowBoxConter {
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-gray;
}

.type-img-box {
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 10px;
  font-size: 14px;
}

.rowBoxTitle {
  width: 30%;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.rowBox {
  padding: 0 15px;
  line-height: 32px;
  display: flex;
}

.imgBoxStype {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 30%;
  height: 25px;
}

.contentColor {
  color: $default-color !important;
}


.list-name-title {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 12px 15px 8px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 5px;
}

.departmentStyle {
  font-size: 14px;
  font-family: PingFang S;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  margin-left: 10px;
}

.menu-down {
  position: fixed;
  top: 44px;
  width: 100%;
  left: 0;
  right: 0;
  z-index: 10000;
}

.height {
  color: $main-bgColor;
}

.noheight {
  color: #FF4B4B;
}

.status-img {
  width: 100px;
  position: absolute;
  right: 30px;
  bottom: 40px;
}

.name-title-box {
  padding: 15px 10px 12px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 8px;
}

.time-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.time-text {
  font-family: PingFang SC;
  font-weight: bold;
  letter-spacing: 1px;
  color: $main-bgColor;
  vertical-align: middle;
}

.van-dropdown-menu__item {
  justify-content: center;
}

.colorName {
  color: $text-gray !important;
}

.nomore {
  font-size: 12px;
  padding-bottom: 10px;
  text-align: center;
  color: #808080;
}

.startStyle {
  text-align: center;
  padding: 5px;
}

.startStyleBox {
  display: flex;
  justify-content: flex-end;
  padding: 3px 10px 7px;
  border-top: 1px solid #EFEFF4;
  margin-top: 10px;
}

.content {
  flex: 1;
  padding-left: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}

.title {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(53, 53, 53, 1);
}

.row {
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  padding: 0 10px 2px;
  line-height: 22px;
}

.nameTitleStyle {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
}

.conterList {
  margin-top: 10px;
  background: #fff;
  position: relative;
}

.conterBox {
  myContent();
  top: 90px;
}

.imgStyle {
  width: 100%;
}

.startStyle {
  text-align: center;
  padding: 5px;
}

.imgStype {
  width: 100%;
}

.btn-block {
  text-align: right;
  margin: auto 10px;
  flex: 2;
  display: flex;
  align-items: center;
}
</style>